import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './PayrollDetail';
import PayrollDetail from './PayrollDetail';
import { StoreState } from 'src/store/reducers';
import { getPayroll, getPayrollsEntities, updatePayroll } from 'src/store/actions/payroll-actions';
import { toast } from 'react-toastify';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.payrolls.current,
        dataEntities: state.payrolls.dataEntities,
        inProgress: state.payrolls.inProgress,
        inProgressEntity: state.payrolls.inProgressEntity,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id: string) => dispatch(getPayroll(id)),
        updatePayroll: ({ status, id, setPopup }: any) =>
            dispatch(
                updatePayroll(
                    { status, id },
                    () => {
                        toast.success('Status changed successfully');
                        setPopup(false);
                    },
                    (errorMessage: string) => {
                        setPopup(false);
                        toast.error(errorMessage);
                    },
                ),
            ),
        getPayrollsEntities: (params: { id: string | number; caseEnt: string }) =>
            dispatch(getPayrollsEntities(params)),
    };
}

const PayrollDetailScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PayrollDetail);

export default PayrollDetailScreen;
